<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :showFooter="showFooter">
    <label v-if="statusSelected == 'approved_by_customer'" class="generalLabel pt-1 pb-3">Al pulsar el boton confirmar se entenderá que el cliente esta de acuerdo con continuar con el proceso de renovación</label>

    <label v-if="statusSelected == 'rejected_by_customer'" class="generalLabel pt-1 pb-3">Al pulsar el boton confirmar se entenderá que el cliente no desea continuar con el proceso de renovación</label>

    <label v-if="statusSelected == 'approved_by_bo'" class="generalLabel pt-1 pb-3">Al pulsar el boton confirmar se procedera a continuar el proceso de renovación</label>

    <label v-if="statusSelected == 'rejected_by_bo'" class="generalLabel pt-1 pb-3">Al pulsar el boton confirmar se procedera a cancelar el proceso de renovación</label>

    <label v-if="statusSelected == 'delivery_success'" class="generalLabel pt-1 pb-3">Al pulsar el botón confirmar se aceptará la renovación (entrega del dispositivo antiguo satisfactoria).</label>

    <label v-if="statusSelected == 'delivery_failure'" class="generalLabel pt-1 pb-3">Al pulsar el botón confirmar se rechazará la renovación (entrega del dispositivo antiguo no satisfactoria).</label>

    <label v-if="statusSelected == 'approval_available_for_bo'" class="generalLabel pt-1 pb-3">Al pulsar el botón confirmar se aceptará la renovación (verificación manual de importe disponible).</label>

    <label v-if="statusSelected == 'rejected_bo_not_available'" class="generalLabel pt-1 pb-3">Al pulsar el botón confirmar se rechazará la renovación (importe no disponible según verificación de BO).</label>

    <label v-if="statusSelected == 'retry_renewal_fee'" class="generalLabel pt-1 pb-3">Al pulsar el botón confirmar se reintentará el cobro de la cuota de renovación del contrato.</label>

    <label v-if="statusSelected == 'cancel_renewal'" class="generalLabel pt-1 pb-3">Al pulsar el botón confirmar se cancelará la renovación y el contrato hijo asociado (si existe). Esta acción es irreversible.</label>
    <!-- <label v-if="statusSelected != 'approved_by_customer' && statusSelected != 'approved_by_bo'" class="generalLabel pt-1 pb-3">Al pulsar el boton confirmar se entenderá que el cliente no desea continuar con el proceso de renovación</label> -->

    <button class="btn btn-primary generalPrimaryButton float-right mt-4" aria-label="Close"
      @click="renewProceed()" :disabled="loadingButton">
      <span v-if="loadingButton" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
      <span v-if="loadingButton">Procesando...</span>
      <span v-else>Confirmar</span>
    </button>
    <button :id="id + 'CierreModal'" style="display: none;" data-dismiss="modal" />
  </Modal>
  <ModalError :id="'modalError'" :modalTitle="'SE HA PRODUCIDO UN ERROR'" :class="'modal'" :showFooter="false"
    :message="errorMessage" :code="errorCode" />
</template>

<script>
import Modal from '../../../Widgets/Shared/Modal.vue';
import ModalError from '../../Shared/ModalError.vue';
import { Modal as ModalBootstrap } from "bootstrap";
import axios from 'axios';

export default {
  name: 'renewProceed',
  props: [
    'id',
    'modalTitle',
    'class',
    'showFooter',
    'statusSelected',
    'renewId'
  ],
  components: {
    Modal,
    ModalError
  },
  data() {
    return {
      renewData: '',
      classes: this.class,
      errorMessage: "",
      errorCode: "",
      loadingButton: false
    }
  },
  methods: {
    closeConfirmModal() {
      const closeBtn = document.getElementById(this.id + 'CierreModal');
      if (closeBtn) closeBtn.click();
    },
    renewProceed() {
      if (this.loadingButton) return;
      this.loadingButton = true;

      const bodyToSend = {
        contractRenewalId: this.renewId,
        status: this.statusSelected
      };
      const isDeliveryCallback = this.statusSelected === 'delivery_success' || this.statusSelected === 'delivery_failure';
      const isApprovalAvailableCallback = this.statusSelected === 'approval_available_for_bo' || this.statusSelected === 'rejected_bo_not_available';
      const isRetryRenewalFeeCallback = this.statusSelected === 'retry_renewal_fee';
      const isCancelRenewalCallback = this.statusSelected === 'cancel_renewal';

      let request;
      if (isCancelRenewalCallback) {
        request = axios.patch(`/bff/contract-renewals/${this.renewId}/cancel`, { reason: 'CANCELLED' });
      } else if (isApprovalAvailableCallback) {
        request = axios.post('/contract-renewals/callback', bodyToSend);
      } else if (isRetryRenewalFeeCallback) {
        request = axios.post('/contract-renewals/retry-renewal', bodyToSend);
      } else if (isDeliveryCallback) {
        request = axios.patch('/contract-renewal/device-delivery-callback', bodyToSend);
      } else {
        request = axios.patch('/contract-renewal/bo-callback', bodyToSend);
      }

      request
        .then(() => {
          if (isCancelRenewalCallback) {
            this.$emit("reloadList", {
              message: "Renovación cancelada correctamente. Si tenía contrato hijo, también fue cancelado."
            });
          } else if (isRetryRenewalFeeCallback) {
            this.$emit("reloadList", {
              message: "Reintento de cobro iniciado. El estado se actualizará cuando el proceso termine.",
              delayedRefetch: 5000
            });
          } else if (isDeliveryCallback || isApprovalAvailableCallback) {
            this.$emit("reloadList");
          } else {
            this.$emit("refreshRenewalList", bodyToSend);
          }
          this.closeConfirmModal();
        })
        .catch((error) => {
          console.log(error);
          this.errorMessage = error.response?.data?.message || 'Ha ocurrido un error inesperado';
          this.errorCode = error.response?.data?.code || '';
          this.closeConfirmModal();
          this.$emit("stateChangeError");
          const errorModal = new ModalBootstrap(document.getElementById('modalError'));
          errorModal.show();
        })
        .finally(() => {
          this.loadingButton = false;
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
